import _ from "lodash";

// Used for token handling
export const getSearchParams = (location) => {
  return new URLSearchParams(location.search);
};

// Used to populate each slide state, timestamp, and the page number [Form Container 327]
export const populateFormsState = (
  clientId,
  projectId,
  projectData,
  slideStates,
  setSlideStates,
  setTimeStamp,
  pageNumber,
  setPageNumber,
  navigate,
) => {
  const [
    slide1,
    slide2,
    slide3,
    slide4,
    slide5,
    slide6,
    slide7,
    slide8,
    slide9,
    slide10,
    slide11,
  ] = slideStates;
  const [
    setSlide1,
    setSlide2,
    setSlide3,
    setSlide4,
    setSlide5,
    setSlide6,
    setSlide7,
    setSlide8,
    setSlide9,
    setSlide10,
    setSlide11,
  ] = setSlideStates;

  setTimeStamp(() => projectData.timeStamp);

  if (!_.isEqual(slide1, projectData.slide1)) {
    setSlide1(() => projectData.slide1);
  }
  if (!_.isEqual(slide2, projectData.slide2)) {
    setSlide2(() => projectData.slide2);
  }
  if (!_.isEqual(slide3, projectData.slide3)) {
    setSlide3(() => projectData.slide3);
  }
  if (!_.isEqual(slide4, projectData.slide4)) {
    setSlide4(() => projectData.slide4);
  }
  if (!_.isEqual(slide5, projectData.slide5)) {
    setSlide5(() => projectData.slide5);
  }
  if (!_.isEqual(slide6, projectData.slide6)) {
    setSlide6(() => projectData.slide6);
  }
  if (!_.isEqual(slide7, projectData.slide7)) {
    setSlide7(() => projectData.slide7);
  }
  if (!_.isEqual(slide8, projectData.slide8)) {
    setSlide8(() => projectData.slide8);
  }
  if (!_.isEqual(slide9, projectData.slide9)) {
    setSlide9((prev) => {
      return {
        ...prev,
        ...projectData.slide9,
      };
    });
  }
  if (!_.isEqual(slide10, projectData.slide10)) {
    setSlide10((prev) => {
      return {
        ...prev,
        ...projectData.slide10,
      };
    });
  }
  if (!_.isEqual(slide11, projectData.slide11)) {
    setSlide11((prev) => {
      return {
        ...prev,
        ...projectData.slide11,
      };
    });
  }

  // If the pageNumber is not equal to the recentSlide, set the pageNumber to the recentSlide
  if (pageNumber !== 0 && pageNumber !== +projectData.recentSlide) {
    navigate(
      `/dashboard/form/${projectData.clientId}/${projectData.id}/${pageNumber}`,
    );
  } else if (pageNumber === 0 && pageNumber !== +projectData.recentSlide) {
    setPageNumber(() => +projectData.recentSlide);
    navigate(
      `/dashboard/form/${projectData.clientId}/${
        projectData.id
      }/${+projectData.recentSlide}`,
    );
  }
};

// ~ Used to update the web form to match database [Form Container 298]
export const updateFormSlidesStatus = async (
  clientId,
  projectId,
  userId,
  currentProjectData,
  pageNumber,
  setRequestStatus,
  updateFormStatus,
  setDisableAll,
  setActiveUserId,
  navigate,
) => {
  let currentStatus = currentProjectData.requestStatus;
  let currentActiveUserId = currentProjectData.activeUserId;

  // If projects status is "I", enable all inputs
  if (currentStatus === "I") {
    setRequestStatus(() => "I");
    setActiveUserId(() => null);
    setDisableAll(() => false);
  } else if (currentStatus === "IP") {
    // If projects status is "IP" and there activeUser is not equal user, disable all inputs
    if (currentActiveUserId !== userId) {
      setRequestStatus(() => "IP");
      setActiveUserId(() => null);
      setDisableAll(() => false);
    } else if (currentActiveUserId === userId) {
      // If projects status is "IP" and there activeUser is equal user, enable all inputs
      setRequestStatus(() => "IP");
      setActiveUserId(() => userId);
      setDisableAll(() => false);
    } else {
      // If projects status is "IP" and there is no activeUser, update the status to "I"
      updateFormStatus.mutate("I", userId);
      setDisableAll(() => false);
      setRequestStatus(() => "I");
      setActiveUserId(() => null);
    }
  } else if (currentStatus === "RV") {
    // If projects status is "RV", set the status to "RV"
    setRequestStatus(() => "RV");
    setDisableAll(() => false);
    setActiveUserId(() => null);
  } else {
    // If projects status is not "I", "IP", or "RV", disable all inputs
    setRequestStatus(() => currentStatus);
  }

  // if pageNumber isn't 0 and project is not null, update the url to match the current slide
  if (pageNumber > 0) {
    navigate(`/dashboard/form/${clientId}/${projectId}/${pageNumber}`, {
      replace: true,
    });
  }
};

export const setReviseStatusPageNumber = (
  invalidSlideNumbers,
  invalidInputs,
  projectData,
  pageNumber,
  setPageNumber,
  navigate,
) => {
  let lowestSlideNumber = +invalidSlideNumbers[0];
  for (const invalidSlide of invalidSlideNumbers) {
    let validity = checkSlideValidity(
      invalidSlide,
      invalidSlideNumbers,
      invalidInputs,
      projectData,
    );
    if (validity === "invalid" && invalidSlide < lowestSlideNumber) {
      lowestSlideNumber = +invalidSlide;
    }
  }

  if (pageNumber !== 0 && pageNumber !== lowestSlideNumber) {
    navigate(
      `/dashboard/form/${projectData.clientId}/${projectData.id}/${pageNumber}`,
    );
  } else if (pageNumber === 0 && pageNumber !== lowestSlideNumber) {
    setPageNumber(() => lowestSlideNumber);
    navigate(
      `/dashboard/form/${projectData.clientId}/${projectData.id}/${lowestSlideNumber}`,
    );
  }
};

// | SLIDES VALIDITY HELPERS |
export const checkSlideValidity = (
  slideNumber,
  invalidSlideNumbers,
  invalidInputs,
  formState,
) => {
  let invalidSlideStatus = "valid";
  // If slideNumber is not in invalidSlideNumbers, return {[slideNumber] : 'valid'}
  if (!invalidSlideNumbers.includes(slideNumber)) {
    return invalidSlideStatus;
  }

  let slideStr = `slide${slideNumber}`;
  let slideState = formState[slideStr];

  // filter invalid inputs by slide number
  let slideInvalidInputs = invalidInputs.filter(
    (input) => input.slide === slideNumber,
  );

  // iterate over the filtered invalid inputs and check if the slide state matches the initial value
  for (const obj of slideInvalidInputs) {
    let inputName = obj.name;
    let inputVal = obj.initialValue;
    if (inputVal === "true") {
      inputVal = true;
    } else if (inputVal === "false") {
      inputVal = false;
    }
    if (slideState[inputName] === inputVal) {
      invalidSlideStatus = "invalid";
      break;
    }
  }

  return invalidSlideStatus;
};

export const getAllSlidesStatus = (
  states,
  slideStatus,
  setSlideStatus,
  currentProjectData,
  userId,
  client,
) => {
  const {
    slide1,
    slide2,
    slide3,
    slide4,
    slide5,
    slide6,
    slide7,
    slide8,
    slide9,
    slide10,
  } = states;

  for (let i = 1; i < 11; i++) {
    if (i === 1 && slide1) {
      getSlideStatus(
        i,
        slide1,
        setSlideStatus,
        currentProjectData,
        userId,
        slideStatus,
      );
    } else if (i === 2 && slide2) {
      getSlideStatus(
        i,
        slide2,
        setSlideStatus,
        currentProjectData,
        userId,
        slideStatus,
        client,
      );
    } else if (i === 3 && slide3) {
      getSlideStatus(
        i,
        slide3,
        setSlideStatus,
        currentProjectData,
        userId,
        slideStatus,
        client,
        slide2,
      );
    } else if (i === 4 && slide4) {
      getSlideStatus(
        i,
        slide4,
        setSlideStatus,
        currentProjectData,
        userId,
        slideStatus,
        client,
      );
    } else if (i === 5 && slide5) {
      getSlideStatus(
        i,
        slide5,
        setSlideStatus,
        currentProjectData,
        userId,
        slideStatus,
      );
    } else if (i === 6 && slide6) {
      getSlideStatus(
        i,
        slide6,
        setSlideStatus,
        currentProjectData,
        userId,
        slideStatus,
      );
    } else if (i === 7 && slide7) {
      getSlideStatus(
        i,
        slide7,
        setSlideStatus,
        currentProjectData,
        userId,
        slideStatus,
      );
    } else if (i === 8 && slide8) {
      getSlideStatus(
        i,
        slide8,
        setSlideStatus,
        currentProjectData,
        userId,
        slideStatus,
      );
    } else if (i === 9 && slide9) {
      getSlideStatus(
        i,
        slide9,
        setSlideStatus,
        currentProjectData,
        userId,
        slideStatus,
      );
    } else if (i === 10 && slide10) {
      getSlideStatus(
        i,
        slide10,
        setSlideStatus,
        currentProjectData,
        userId,
        slideStatus,
        client,
      );
    }
  }
};

export const getSlideStatus = (
  pageNumber,
  slideState,
  setSlideStatus,
  formData,
  userId,
  slideStatus,
  client = null,
  slide2 = null,
) => {
  if (pageNumber === 1) {
    const { projectName, totAcr, distAcr, projectType, totalBldLots } =
      slideState;

    if (
      (projectName &&
        totAcr &&
        distAcr &&
        projectType &&
        (projectType === "residential" ||
          projectType === "commercial" ||
          projectType === "development & commercial" ||
          projectType === "development & residential") &&
        totalBldLots) ||
      (projectType !== "residential" &&
        projectType !== "commercial" &&
        projectType !== "development & residential" &&
        projectType !== "development & commercial" &&
        !totalBldLots)
    ) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide1: "complete",
        };
      });
    } else {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide1: "incomplete",
        };
      });
    }
  } else if (pageNumber === 2) {
    const { safetyInterest, level1Safety, level2Safety } = slideState;

    if (client && client.shortName === "Greystone") {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide2: "disabled",
        };
      });
      return;
    }
    if (
      safetyInterest === "Yes" &&
      level1Safety === "No" &&
      level2Safety === "No"
    ) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide2: "incomplete",
        };
      });
    } else if (safetyInterest === "No" || safetyInterest === "") {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide2: "complete",
        };
      });
    } else if (
      safetyInterest === "Yes" &&
      (level1Safety === "Yes" || level2Safety === "Yes")
    ) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide2: "complete",
        };
      });
    }
  } else if (pageNumber === 3) {
    const { noiRequest, noiFilingDate, permittee } = slideState;
    if (noiRequest && !noiFilingDate) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide3: "incomplete",
        };
      });
    } else if (noiRequest && !permittee) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide3: "incomplete",
        };
      });
    } else if (noiRequest && permittee && noiFilingDate) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide3: "complete",
        };
      });
    }
  } else if (pageNumber === 4) {
    const { filePermitRequest, amendPermitRequest, authorizationLetter } =
      slideState;
    if (client && client.shortName === "Greystone") {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide4: "disabled",
        };
      });
      return;
    }
    if (filePermitRequest === true || amendPermitRequest === true) {
      if (
        authorizationLetter.isSigned === "Yes" ||
        authorizationLetter.isSigned === "tru"
      ) {
        setSlideStatus((prev) => {
          return {
            ...prev,
            slide4: "complete",
          };
        });
      } else {
        console.log("Incomplete Slide 4: ");
        setSlideStatus((prev) => {
          return {
            ...prev,
            slide4: "incomplete",
          };
        });
      }
    } else {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide4: "complete",
        };
      });
    }
  } else if (pageNumber === 5) {
    const {
      oName,
      oAdd,
      oState,
      oCity,
      oZip,
      oPhone,
      oFax,
      oTaxId,
      oContactName,
      oContactTitle,
      oContactPhone,
      oContactEmail,
    } = slideState;

    if (
      oName &&
      oAdd &&
      oState &&
      oCity &&
      oZip &&
      oPhone &&
      oFax &&
      oTaxId &&
      oContactName &&
      oContactTitle &&
      oContactPhone &&
      oContactEmail
    ) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide5: "complete",
        };
      });
    } else {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide5: "incomplete",
        };
      });
    }
  } else if (pageNumber === 6) {
    const {
      gcName,
      gcAdd,
      gcState,
      gcCity,
      gcZip,
      gcPhone,
      gcFax,
      gcTaxId,
      gcContactName,
      gcContactTitle,
      gcContactPhone,
      gcContactEmail,
    } = slideState;

    if (
      gcName &&
      gcAdd &&
      gcState &&
      gcCity &&
      gcZip &&
      gcPhone &&
      gcFax &&
      gcTaxId &&
      gcContactName &&
      gcContactTitle &&
      gcContactPhone &&
      gcContactEmail
    ) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide6: "complete",
        };
      });
    } else {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide6: "incomplete",
        };
      });
    }
  } else if (pageNumber === 7) {
    const {
      dustCertificationNumber,
      dustCertificationExpiration,
      projectManagerName,
      projectManagerCell,
      projectManagerPhone,
      projectManagerEmail,
    } = slideState;

    if (
      projectManagerName &&
      projectManagerCell &&
      projectManagerPhone &&
      projectManagerEmail
    ) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide7: "complete",
        };
      });
    } else {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide7: "incomplete",
        };
      });
    }
  } else if (pageNumber === 8) {
    const {
      startDate,
      endDate,
      offsites,
      offsiteDescription,
      activitiesDescription,
    } = slideState;
    if (!startDate || !endDate) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide8: "incomplete",
        };
      });
    } else if (offsites === "Yes" && offsiteDescription === "") {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide8: "incomplete",
        };
      });
    } else if (!activitiesDescription) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide8: "incomplete",
        };
      });
    } else {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide8: "complete",
        };
      });
    }
  } else if (pageNumber === 9) {
    const {
      pAdd,
      pCity,
      pZip,
      pCounty,
      crossRoad1,
      crossRoad2,
      cornerDirection,
      parcelNumbers,
    } = slideState;

    if (
      pAdd &&
      pCity &&
      pZip &&
      pCounty &&
      crossRoad1 &&
      crossRoad2 &&
      cornerDirection &&
      parcelNumbers
    ) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide9: "complete",
        };
      });
    } else {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide9: "incomplete",
        };
      });
    }
  } else if (pageNumber === 10) {
    const {
      billingCompany,
      billingAdd,
      billingCity,
      billingState,
      billingZip,
      billingPhone,
      billingFax,
      billingContactName,
      billingContactTitle,
      billingContactPhone,
      billingContactEmail,
    } = slideState;

    if (client && client.shortName === "Greystone") {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide10: "disabled",
        };
      });
      return;
    }

    if (
      billingCompany &&
      billingAdd &&
      billingCity &&
      billingState &&
      billingZip &&
      billingPhone &&
      billingFax &&
      billingContactName &&
      billingContactTitle &&
      billingContactPhone &&
      billingContactEmail
    ) {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide10: "complete",
        };
      });
    } else {
      setSlideStatus((prev) => {
        return {
          ...prev,
          slide10: "incomplete",
        };
      });
    }
  }
};

// | General Helpers |

// Used to adjust the state field for individuals with names
export function adjustContactNameId(id) {
  const idsWithNames = [
    "inspector",
    "dc",
    "emergencyContact",
    "bmpContact",
    "odr",
    "oContact",
    "gcContact",
    "gcContact2",
    "gcContact3",
  ];
  if (idsWithNames.includes(id)) return `${id}Name`;
  if (id === "waterServices") return `${id}Contact`;

  return id;
}

// | INPUT HELPERS |
// Used to populate the placeholder for an input field
export function handleKeyDown(
  e,
  idProp,
  state,
  setState,
  autoData,
  placeholder,
  debouncedSave,
  setIsLoading,
  setPlaceholder,
  setShowPlaceholder,
  setOpen,
  setOpenHelper,
) {
  let newState;
  if (
    autoData &&
    (e.key === "Tab" || e.key === "ArrowRight") &&
    placeholder !== ""
  ) {
    e.preventDefault();
    newState = { ...state, [idProp]: placeholder };
    setState(newState);
    if (debouncedSave && setIsLoading) {
      setIsLoading(true);
      debouncedSave.mutate(newState);
    }
    setPlaceholder("");
    setShowPlaceholder(false);
    setOpen(false);
    setOpenHelper(false);

    const currentInput = document.getElementsByClassName(`${idProp}-input`)[0];

    currentInput.blur();
  }
}

// | Number Event Handler |
export function updateNumber(
  idProp,
  value,
  state,
  setState,
  debouncedSave,
  setIsLoading,
) {
  let newState = {};
  if (idProp === "sNum") {
    newState = { ...state, [idProp]: value.toString() };
    setState(newState);
    if (debouncedSave && setIsLoading) {
      setIsLoading(true);
      debouncedSave.mutate(newState);
    }
    return;
  }
  let num = value.replace(/[^0-9.]/g, "");

  if (typeof acr === "number") {
    num = num.toString();
  }

  newState = { ...state, [idProp]: num };
  setState(newState);

  if (debouncedSave && setIsLoading) {
    setIsLoading(true);
    debouncedSave.mutate(newState);
  }

  return;
}

// | Phone Numbers Helpers |
export function locatedPhoneNumber(formState, name, nameId) {
  const namePhoneKey = {
    projectManager: ["projectManagerPhone", "3"],
    siteContactName: ["siteContactPhone", "3"],
    oContactName: ["oContactPhone", "5"],
    gcContactName: ["gcContactPhone", "6"],
    billingContactName: ["billingContactPhone", "7"],
    submitterName: ["submitterPhone", "8"],
  };

  let suggestedPhone = undefined;
  // Iterate over each key where key starts with "slide"
  for (const nameProp in namePhoneKey) {
    if (nameProp === nameId) continue;
    let slideStr = `slide${namePhoneKey[nameProp][1]}`;
    let slideState = formState[slideStr];
    let phoneProp = namePhoneKey[nameProp][0];

    if (slideState[nameProp] === name && slideState[phoneProp] !== "") {
      suggestedPhone = slideState[phoneProp];
      break;
    }
  }
  // If not, return undefined
  return suggestedPhone;
}

// | TITLE Helpers |
export function locatedTitle(formState, name, nameId) {
  const nameTitleKey = {
    siteContactName: ["siteContactTitle", "3"],
    projectManagerName: ["projectManagerTitle", "3"],
    oContactName: ["oContactTitle", "5"],
    oAuthorizedContactName: ["oAuthorizedContactTitle", "5"],
    gcContactName: ["gcContactTitle", "6"],
    gcAuthorizedContactName: ["oAuthorizedContactTitle", "6"],
    billingContactName: ["billingContactTitle", "7"],
    submitterName: ["submitterTitle", "8"],
  };

  let suggestedTitle = undefined;

  for (const nameProp in nameTitleKey) {
    if (nameProp === nameId) continue;
    let slideStr = `slide${nameTitleKey[nameProp][1]}`;
    let slideState = formState[slideStr];
    let titleProp = nameTitleKey[nameProp][0];

    if (slideState[nameProp] === name && slideState[titleProp] !== "") {
      suggestedTitle = slideState[titleProp];
      break;
    }
  }
  // If not, return undefined
  return suggestedTitle;
}

// Show placeholder for title function
export const handleShowTitlePlaceholder = (
  idProp,
  state,
  formData,
  placeholder,
  setPlaceholder,
  setSuggestedTitle,
  showPlaceholder,
) => {
  if (showPlaceholder && state[idProp] === "") {
    const contactNameId = adjustContactNameId(idProp.slice(0, -5));
    const contactName = state[contactNameId];
    if (formData) {
      const potentialTitle = locatedTitle(formData, contactName, contactNameId);

      if (potentialTitle) {
        setPlaceholder(potentialTitle);
        setSuggestedTitle(potentialTitle);
      }
    }
  } else if (!showPlaceholder && placeholder !== "") {
    setPlaceholder("");
  } else if (
    showPlaceholder &&
    state[idProp] !== "" &&
    !placeholder.toLowerCase().startsWith(state[idProp].toLowerCase())
  ) {
    setPlaceholder("");
  }
};

// Show placeholder for phone function
export const handleShowPhonePlaceholder = (
  idProp,
  state,
  formData,
  placeholder,
  setPlaceholder,
  setSuggestedPhone,
  showPlaceholder,
) => {
  if (
    showPlaceholder &&
    state[idProp] === "" &&
    idProp !== "oPhone" &&
    idProp !== "gcPhone"
  ) {
    let contactNameId = adjustContactNameId(idProp.slice(0, -5));
    let contactName = state[contactNameId];

    if (formData) {
      let potentialPhone = locatedPhoneNumber(
        formData,
        contactName,
        contactNameId,
      );

      if (potentialPhone && !placeholder.startsWith(potentialPhone)) {
        setPlaceholder(potentialPhone);
        setSuggestedPhone(potentialPhone);
      }
    }
  } else if (showPlaceholder === false && placeholder !== "") {
    setPlaceholder("");
  } else if (
    showPlaceholder === true &&
    state[idProp] !== "" &&
    !placeholder.startsWith(state[idProp])
  ) {
    setPlaceholder("");
  }
};

// |EMAIL Helpers |
export const findMatchingEmail = (formState, name, nameId) => {
  if (!name) return;
  const nameEmailKey = {
    projectManagerName: ["projectManagerEmail", "3"],
    siteContactName: ["siteContactEmail", "3"],
    oContactName: ["oContactEmail", "5"],
    gcContactName: ["gcContactEmail", "6"],
    billingContactName: ["billingContactEmail", "7"],
    submitterName: ["submitterEmail", "8"],
  };

  let suggestedEmail = undefined;

  for (const nameProp in nameEmailKey) {
    if (nameProp === nameId) continue;
    let slideStr = `slide${nameEmailKey[nameProp][1]}`;
    let slideState = formState[slideStr];
    let emailProp = nameEmailKey[nameProp][0];

    if (slideState[nameProp] === name && slideState[emailProp] !== "") {
      suggestedEmail = slideState[emailProp];
      break;
    }
  }
  return suggestedEmail;
};

export const generateEmail = (name, domain) => {
  return name.split(" ").join("").toLowerCase() + domain;
};

export function findMostCommonDomain(emailsArr) {
  if (!emailsArr || emailsArr.length === 0) return false;
  const domainCount = {};

  emailsArr.forEach((email) => {
    const domain = `@${email.split("@")[1]}`;

    if (domainCount[domain]) {
      domainCount[domain]++;
    } else {
      domainCount[domain] = 1;
    }
  });

  let mostCommonDomain = Object.keys(domainCount).reduce((a, b) => {
    return domainCount[a] > domainCount[b] ? a : b;
  });

  return mostCommonDomain;
}

export const handleShowEmailPlaceholder = (
  idProp,
  state,
  formData,
  placeholder,
  setPlaceholder,
  setSuggestedEmail,
  showPlaceholder,
) => {
  if (showPlaceholder && state[idProp] === "") {
    const contactNameId = adjustContactNameId(idProp.slice(0, -5));
    const contactName = state[contactNameId];

    if (formData) {
      const potentialEmail = findMatchingEmail(
        formData,
        contactName,
        contactNameId,
      );
      if (potentialEmail) {
        setPlaceholder(potentialEmail);
        setSuggestedEmail(potentialEmail);
      }
    }
  } else if (!showPlaceholder && placeholder !== "") {
    setPlaceholder("");
  } else if (
    showPlaceholder &&
    state[idProp] !== "" &&
    !placeholder.startsWith(state[idProp])
  ) {
    setPlaceholder("");
  }
};

// Used to scroll to the first required field on the current slide
export const scrollToFirstRequiredField = (state) => {
  const requiredInputs = document.querySelectorAll(".required");

  // ^ IF NO REQUIRED INPUTS
  if (requiredInputs.length === 0) {
    window.scrollTo(0, 0);
    return;
  }

  const firstRequired = requiredInputs[0];
  const slideKeys = Object.keys(state);
  const textClassList = [...firstRequired.classList];

  if (textClassList.includes("date-picker")) {
    if (textClassList.includes("endDate-input")) {
      const requiredField = document.getElementsByClassName("endDate-input")[0];
      requiredField.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      requiredField.focus();
    } else if (textClassList.includes("startDate-input")) {
      const requiredField =
        document.getElementsByClassName("startDate-input")[0];
      requiredField.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      requiredField.focus();
    }
    return;
  }
  let textClass = "";
  // ^ IF TEXT FIELD |
  if (textClassList.includes("form-text-root")) {
    for (let i = 0; i < textClassList.length; i++) {
      textClass = textClassList[i];
      if (slideKeys.includes(textClass)) {
        textClass = `${textClass}-input`;
        break;
      }
    }
    const requiredField = document.getElementsByClassName(textClass)[0];
    requiredField.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });

    requiredField.focus();
    // ^ IF RADIO
  } else {
    const classList = [...firstRequired.classList];
    let radioClass = "";
    for (let i = 0; i < classList.length; i++) {
      radioClass = classList[i];
      if (slideKeys.includes(radioClass)) {
        radioClass = `${radioClass}-radio`;
        break;
      }
    }

    const requiredRadio = document.getElementsByClassName(radioClass)[0];

    requiredRadio.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }
};
